(function($) {
	
	formHelper.addRule({
		form: '.form-manage-premium-coupons',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {

				if(this.data.systemMessage1) {

					$( ".alert-success" ).each(function( index ) {
						$( this ).css("display", "none");
					}
					);

					$('#system-message-1').html(this.data.systemMessage1);

				}
			}
		}

});

})(jQuery);


